import { Col, DatePicker, Form, Input, InputNumber, Radio, Row } from 'antd'
import React, { useState } from 'react'
import { t } from 'i18next'
import TextArea from 'antd/es/input/TextArea'
import PhoneInput from 'react-phone-number-input'
import ZipCodeSearchField from '../../Public/Slot/ZipCodeSearchField'
const { RangePicker } = DatePicker

export default function SlotForm ({ form, onFinish, edit, rangeDisable, postalPlace, disabled = false, specialist = false }) {
  const [ageRequired, setAgeRequired] = useState(true)
  const onDateChange = (value) => {
    if (value[0].isSame(value[1])) {
      form.setFieldsValue({ range: [value[0], value[1].add(1, 'hour')] })
    }
    form.setFieldsValue({ appointment_date: value[0] })
  }

  return (
    <Form
      id="SlotFormAdmin"
      size='small'
      form={form}
      labelAlign='left'
      layout='vertical'
      onFinish={onFinish}
      disabled={disabled}
    >

      <Form.Item name="type"
        rules={[{ required: true, message: t('rules.required') }]}
      >
        <Radio.Group disabled={edit} onChange={(e) => { console.log(e); setAgeRequired(e.target.value === 'PatientSlot') }}>
          <Radio value='PatientSlot'>{t('Admin.SlotForm.type.PatientSlot')}</Radio>
          <Radio value='MaintenanceSlot'>{t('Admin.SlotForm.type.MaintenanceSlot')}</Radio>
          <Radio value='CleaningSlot'>{t('Admin.SlotForm.type.CleaningSlot')}</Radio>
        </Radio.Group>
      </Form.Item>
      {edit &&
        <Row gutter={16}>
          <Col>
            <Form.Item name="box_data" label={t('Admin.SlotForm.box')}>
              <Input disabled={true} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="interphone" label={t('Admin.SlotForm.interphone')}>
              <Input disabled={true} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="assigned" label={t('Admin.SlotForm.assigned')}>
              <Input disabled={true} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="created_by" label={t('Admin.SlotForm.createdBy.label')}>
              <Input disabled={true} />
            </Form.Item>
          </Col>
        </Row>
      }
      <Row gutter={16}>
        <Col>
          <Form.Item name="created_at" label={t('Admin.SlotForm.created_at')}>
            <DatePicker disabled={true} format={'DD/MM/YY HH[h]mm'} />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name="range" label={t('Admin.SlotForm.range')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <RangePicker
              onChange={onDateChange}
              showTime={{ format: 'HH[h]mm' }}
              format={'DD/MM/YY HH[h]mm'}
              disabled={rangeDisable} />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name="appointment_date" label={t('Admin.SlotForm.appointment_date')} >
            <DatePicker
              format={'DD/MM/YY HH[h]mm'}
              disabled />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        {edit && <Col>
          <Form.Item name="digicode" label={t('Admin.SlotForm.digicode')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <Input />
          </Form.Item>
        </Col>}
        {edit && specialist &&
          <Col span={10}>
            <Form.Item name="specialist_name" label={t('Admin.SlotForm.specialistName')} >
              <Input disabled />
            </Form.Item>
          </Col>
        }
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="first_name" label={t('Admin.SlotForm.first_name')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="last_name" label={t('Admin.SlotForm.last_name')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="age" label={t('Admin.SlotForm.age')}
            extra={t('Admin.SlotForm.age_extra')} >
            <InputNumber min={0} max={150} disabled={!ageRequired} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col style={{ maxWidth: '25%' }}>
          <Form.Item name="phone" label={t('Admin.SlotForm.phone')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <PhoneInput className='ant-input css-dev-only-do-not-override-xfszwz' disabled={disabled}
              international defaultCountry={'FR'}
            />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name="email" label={t('Admin.SlotForm.email')}>
            <Input />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name="postal_place_id" label={t('Admin.SlotForm.zip_code')}>
            <ZipCodeSearchField form={form} defaultValue={postalPlace} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="comment" label={t('Admin.SlotForm.comment')}>
        <TextArea rows={5} />
      </Form.Item>
      <Form.Item name="is_now">
        <Input type='hidden' />
      </Form.Item>
    </Form>
  )
}
